export const lightOrange = "#ffc14d";
export const lightRed = "#ff6961";
export const lightGreen = "#90ee90";
export const lightPurple = "#cda5f3";
export const lightBlue = "#03a9f4";
//background: linear-gradient(to right, #667db6, #0082c8, #0082c8, #667db6);